export function verificarIdade(dataSelecionada: Date): boolean {
    const hoje = new Date();
    const dataMinima = new Date(
        hoje.getFullYear() - 18, 
        hoje.getMonth(), 
        hoje.getDate()
    );

    return dataSelecionada <= dataMinima;
}